var map = {
	"./ar/about.json": 3009,
	"./de/about.json": 4482,
	"./en/about.json": 6944,
	"./es/about.json": 1248,
	"./fr/about.json": 5345,
	"./pt/about.json": 5897,
	"./ru/about.json": 3050
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3399;